module.exports = __webpack_public_path__ + "82ebadf47c7f1c7e5328e289ef5617c3.svg";